function buildForm(name, email, product) {
  $('#wufoo-s1pmxncg015q3pu').html('');
  const defaults = 'field14='+name+'&field5='+email+'&field6='+product;

  var s1pmxncg015q3pu; (function(d, t) { var s = d.createElement(t), options = { 'userName':'ardbeg', 'formHash':'s1pmxncg015q3pu', 'autoResize':true, 'height':'400', 'async':true, 'defaultValues':defaults, 'host':'wufoo.com', 'header':'show', 'ssl':true }; s.src = ('https:' == d.location.protocol ?'https://':'http://') + 'secure.wufoo.com/scripts/embed/form.js'; s.onload = s.onreadystatechange = function() { var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return; try { s1pmxncg015q3pu = new WufooForm(); s1pmxncg015q3pu.initialize(options); s1pmxncg015q3pu.display(); } catch (e) { } }; var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr); })(document, 'script'); 
}

$('.button.enquiry').on('click', function(e) {
  e.preventDefault();
  
  $('.popup-overlay.enquiry.hidden').removeClass('hidden');
  buildForm($(this).attr('data-name'), $(this).attr('data-email'), $(this).attr('data-product'));
  $('.popup-close').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.popup-overlay').addClass('hidden');
  });
});